import { useEffect } from 'react';

import MarketTrend from '../MarketTrend';

import { Helmet } from "react-helmet";

const MarketTrendUS = () => {
	useEffect(() => {
		let pageLastViewed = localStorage.getItem("page-last-viewed");
		pageLastViewed = JSON.parse(pageLastViewed);
		pageLastViewed.markettrend.us = new Date().getTime();
		localStorage.setItem("page-last-viewed", JSON.stringify(pageLastViewed));
	}, [ ]);

	return (
		<>
			<Helmet>
				<title>Market Trend (US) - Finetic App</title>
			</Helmet>
			<MarketTrend exchange="US" />
		</>
	);
};

export default MarketTrendUS;
